import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ShouldConvertWalkingFarmCountErrors } from '../../typings/property-force-api';

@Injectable({
  providedIn: 'root'
})
export class WalkingFarmCountInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    let handledRequest: Observable<HttpEvent<unknown>>;

    if (request.context.get(ShouldConvertWalkingFarmCountErrors)) {
      handledRequest = next.handle(request).pipe(
        switchMap((event) => {
          const handledEvent = of(event);
          if (event instanceof HttpResponse) {
            const count = event.body?.d?.Count ?? 0;
            if (count === 0 || count > 1000) {
              return throwError(
                () =>
                  new Error(
                    count === 0
                      ? 'Your request did not return any records.'
                      : 'Your request has exceeded the max number of records (1000). Please refine your search.'
                  )
              );
            }
          }
          return handledEvent;
        })
      );
    } else {
      handledRequest = next.handle(request);
    }
    return handledRequest;
  }
}
